module.exports = "https://static.energy5.com/_next/static/images/mapcity-3f75de0f5ba9daf76aa1ab616ab35734.png";